import { Alert, Snackbar } from '@mui/material';
import { duration } from 'dayjs';
import { FunctionComponent } from 'react';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { useAppDispatch } from '../../store/Hooks';


export const GameplayErrorMessage: FunctionComponent = () => {
	const dispatch = useAppDispatch();

	const error = useGameplaySelector(gamePlayStore.selectors.error);

	function handleClose() {
		dispatch(gamePlayStore.actions.clearError());
	}

	return <Snackbar
		open={error !== undefined}
		onClose={handleClose}
		autoHideDuration={duration(6, 'seconds').asMilliseconds()}
		anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
	>
		<Alert severity='warning'>{error}</Alert>
	</Snackbar>;
};